module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-7-096c43c0.png";